export function isLkChat() {
    const { pathname } = window.location;
    return pathname.indexOf('/lk/chat') !== -1;
}

export function isPublicMode() {
    const { pathname } = window.location;
    return pathname.indexOf('/ai/') !== -1;
}

export function isImageGeneration() {
    const { pathname } = window.location;
    return pathname.indexOf('/ai/generate-image') !== -1 || pathname.indexOf('/ai/generate-logo') !== -1 || pathname.indexOf('/ai/generate-cover') !== -1;
}

export function isPublicWidget() {
    const { pathname } = window.location;
    return pathname.indexOf('/ai/napisat-doklad') !== -1 || pathname.indexOf('/ai/napisat-referat') !== -1;
}